// extracted by mini-css-extract-plugin
export default {"appbar":"SideMenu_appbar__0qOr1"};